import { FOCUS_RING_SHADOW } from "@3sc/common-component";

/* Shared style tokens for the NewLogin auth screens.
 * Extracted so LoginPage / ForgotPasswordPage / EmailSentPage share a single
 * definition instead of copy-pasting these objects (SonarQube duplication). */

export const FONT = "'Euclid Circular B', sans-serif";
export const FONT_REGULAR = "'Euclid Circular Light', sans-serif";

export const labelSx = {
  fontFamily: FONT_REGULAR,
  fontSize: "1.143rem",
  fontWeight: 300,
  lineHeight: "1.429rem",
  color: "#474849",
  display: "block",
  mb: "0.271rem",
};

export const inputSx = {
  "& .MuiOutlinedInput-root": {
    height: "3.429rem",
    borderRadius: "0.286rem",
    fontFamily: FONT,
    fontSize: "1.048rem",
    fontWeight: 300,
    lineHeight: "1.1233rem",
    color: "#525252",
    "& fieldset": { borderColor: "#D0D4DA" },
    "&:hover fieldset": { borderColor: "#07080B" },
    "&.Mui-focused fieldset": { borderColor: "#07080B", borderWidth: "0.095rem" },
    "&.Mui-focused": { boxShadow: FOCUS_RING_SHADOW },
  },
  "& input::placeholder": { color: "#525252", opacity: 1 },
  "& .MuiFormHelperText-root": { fontFamily: FONT, fontSize: "0.952rem" },
};

/* Same as inputSx plus the Chrome autofill background fix (used by LoginPage). */
export const inputSxWithAutofillFix = {
  ...inputSx,
  "& .MuiOutlinedInput-input": {
    WebkitBoxShadow: "0 0 0 30px white inset !important", // autofill fix
  },
};
